import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const liveRequests = [
  { tag: 'SEO', city: 'Москва', time: '12с назад', text: '«Ищу подрядчика для SEO интернет-магазина»', status: 'ИИ начал диалог' },
  { tag: 'CRM', city: 'СПб', time: '38с назад', text: '«Посоветуйте интегратора Bitrix24»', status: 'ИИ начал диалог' },
  { tag: 'РК', city: 'Казань', time: '1м назад', text: '«Нужно агентство для Яндекс Директ, бюджет от 300к»', status: 'ИИ начал диалог' },
  { tag: 'WEB', city: 'Москва', time: '2м назад', text: '«Подрядчик на разработку корпоративного сайта»', status: 'ИИ начал диалог' },
  { tag: 'SMM', city: 'Сочи', time: '3м назад', text: '«Кто ведёт Telegram-канал под ключ?»', status: 'ИИ начал диалог' },
];

const checklist = [
  'Более 200 000 Telegram-чатов под мониторингом',
  'До 30 секунд от запроса до первого контакта',
  'ИИ ведёт диалог 24/7 без участия менеджера',
  'Назначает встречи и передаёт готовых лидов',
];

export default function TLHero() {
  const { ref: badgeRef, revealed: badgeRevealed } = useScrollReveal({ delay: 100 });
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 200 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 350 });
  const { ref: btnsRef, revealed: btnsRevealed } = useScrollReveal({ delay: 500 });
  const { containerRef: listRef, revealedCount: listRevealed } = useScrollRevealGroup<HTMLUListElement>(4);

  return (
    <section className="relative bg-background-50 overflow-hidden pt-28 md:pt-36 pb-20 md:pb-28">
      <div className="absolute -top-32 -right-32 w-[560px] h-[560px] rounded-full bg-primary-500/5 pointer-events-none"></div>
      <div className="absolute -bottom-20 -left-20 w-[360px] h-[360px] rounded-full bg-primary-500/5 pointer-events-none"></div>

      <div className="relative max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div
              ref={badgeRef}
              className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-background-200 bg-background-100/60 reveal-fade-up ${badgeRevealed ? 'revealed' : ''}`}
            >
              <span className="relative flex w-2 h-2">
                <span className="absolute inline-flex w-full h-full rounded-full bg-primary-500 live-dot"></span>
              </span>
              <span className="text-[12px] font-medium text-foreground-600 tracking-wide uppercase">
                СИСТЕМА В РАБОТЕ · Telegram-мониторинг 24/7
              </span>
            </div>

            <h1
              ref={titleRef}
              className={`mt-6 font-display font-extrabold text-[40px] md:text-[56px] leading-[1.05] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
            >
              ИИ-который сам находит клиентов в <span className="relative inline-block"><span className="text-primary-500">Telegram</span><span className="absolute -bottom-1 left-0 right-0 h-1 bg-primary-500/50 rounded-full"></span></span>
            </h1>

            <p
              ref={descRef}
              className={`mt-6 text-[17px] md:text-[19px] leading-relaxed text-foreground-500 max-w-[620px] reveal-fade-up ${descRevealed ? 'revealed' : ''}`}
            >
              AIGAM анализирует более 200 000 Telegram-чатов, находит потенциальных клиентов, начинает персональный диалог, квалифицирует лидов и передаёт вашей команде только заинтересованных покупателей.
            </p>

            <div
              ref={btnsRef}
              className={`mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 reveal-fade-up ${btnsRevealed ? 'revealed' : ''}`}
            >
              <a
                href="https://lk.aigam.ru"
                className="h-12 px-7 inline-flex items-center justify-center rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-[15px] font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                Получить демо
                <i className="ri-arrow-right-line ml-2 text-lg"></i>
              </a>
              <a
                href="#how"
                className="h-12 px-6 inline-flex items-center justify-center rounded-md border border-background-200 hover:border-background-300 hover:bg-background-100 text-foreground-700 text-[15px] font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Как это работает
              </a>
            </div>

            <ul
              ref={listRef}
              className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 max-w-[620px]"
            >
              {checklist.map((item, i) => (
                <li
                  key={item}
                  className={`flex items-start gap-2.5 text-[14px] text-foreground-600 reveal-fade-up ${i < listRevealed ? 'revealed' : ''}`}
                  style={i < listRevealed ? { transitionDelay: `${i * 80}ms` } : undefined}
                >
                  <span className="mt-0.5 w-4 h-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 shrink-0">
                    <i className="ri-check-line text-[12px]"></i>
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5 relative">
            <div className="relative rounded-2xl bg-background-950 text-background-50 p-5 border border-background-800">
              <div className="flex items-center justify-between pb-4 border-b border-background-50/10">
                <div className="flex items-center gap-2">
                  <span className="w-2.5 h-2.5 rounded-full bg-accent-400 live-dot"></span>
                  <span className="text-[12px] font-medium text-background-50/70 uppercase tracking-wider">
                    Live monitor
                  </span>
                </div>
                <span className="text-[12px] text-background-50/40">
                  {new Date().toLocaleDateString('ru-RU')}
                </span>
              </div>
              <div className="mt-4 space-y-3 max-h-[380px] overflow-hidden">
                {liveRequests.map((req, i) => (
                  <div
                    key={i}
                    className="fade-up rounded-lg border border-background-50/10 bg-background-900/60 p-3.5"
                    style={{ animationDelay: `${i * 120}ms` }}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="text-[10px] font-bold px-2 py-0.5 rounded bg-primary-500/15 text-primary-400 tracking-wider">
                          {req.tag}
                        </span>
                        <span className="text-[11px] text-background-50/40">{req.city}</span>
                      </div>
                      <span className="text-[11px] text-background-50/40">{req.time}</span>
                    </div>
                    <p className="mt-2 text-[13.5px] text-background-50/85 leading-snug">
                      {req.text}
                    </p>
                    <div className="mt-2 flex items-center gap-1.5 text-[11px] text-accent-400">
                      <i className="ri-check-double-line"></i>
                      <span>{req.status}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-4 pt-4 border-t border-background-50/10 flex items-center justify-between text-[12px]">
                <span className="text-background-50/50">Найдено сегодня</span>
                <span className="text-background-50 font-semibold tabular-nums">47 запросов</span>
              </div>
            </div>
            <div className="absolute -top-3 -right-3 rounded-lg bg-primary-500 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider text-background-50 shadow-lg">
              <i className="ri-radar-line mr-1"></i> Real-time
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}